import React, { Component } from "react";
import { graphql } from "gatsby";
import Layout from "../components/layout";
import SEO from "../components/seo";

class Pricing extends Component {
  constructor(props) {
    super(props);
    this.removeUrl = this.removeUrl.bind(this);
  }

  removeUrl(url) {
    let arr = url.split("/");
    arr.splice(0, 3);
    return arr.join("/");
  }

  render() {
    return (
      <Layout location="testimonials">
        <SEO title="Testimonials" />
        <section className="section pricing-items">
          <div className="container">
            <div className="columns is-mobile is-multiline">
              <div className="column is-full">
                <h1>Testimonials</h1>
              </div>

              {this.props.data.allWordpressWpTestimonials.edges.map(
                ({ node }) => (
                  <div className="testimonial">
                    <p>{node.acf.quote}</p>
                    <p className="has-text-right">- {node.acf.attribution}</p>
                    {/* <Card
                          className="column is-full-mobile is-half-tablet is-one-third-desktop"
                          attribution={node.acf.attribution}
                          quote={node.acf.quote}
                        /> */}
                  </div>
                )
              )}
            </div>
          </div>
        </section>
      </Layout>
    );
  }
}

export default Pricing;

export const query = graphql`
  query TestimonialsPageQuery {
    allWordpressWpTestimonials {
      edges {
        node {
          acf {
            quote
            attribution
          }
        }
      }
    }
  }
`;
